import { SUBMIT_FORM_ACTION } from '@plone/volto-form-block/constants/ActionTypes';

// Mirrors volto-form-block submitForm but adds the occasion UID as a top-level
// body key (survives backend cleanup_data; read by OccasionEmailOverrideProcessor, #1663).
export function submitEventRegistrationForm(
  path = '',
  block_id: string,
  data: Record<string, unknown>,
  captcha?: unknown,
  occasion?: string,
) {
  return {
    type: SUBMIT_FORM_ACTION,
    subrequest: block_id,
    request: {
      op: 'post',
      path: `${path}/@schemaform-data`,
      data: { block_id, data, captcha, occasion },
    },
  };
}
